export interface FaxEmailItemView {
   faxEmailAddressId: number | null;
   emailAddress: string;
   extensionId: number;
   isDeleted: boolean;
}

export const faxEmailAddressesFields: string[] = ['emailAddress', 'extensionId', 'isDomainOnly'];
